<template>
  <el-dropdown split-button type="info" class="dropdownButton" size="mini" style="width: 108px; margin-left: 0">
    顺丰微派
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item>
        <el-button @click="weipai('place')" style="width: 108px" type="primary" size="mini">电子面下单</el-button>
      </el-dropdown-item>
      <el-dropdown-item>
        <el-button @click="weipai('subscribe')" style="width: 108px" type="primary"
          size="mini">订阅单</el-button>
      </el-dropdown-item>
      <el-dropdown-item>
        <el-button @click="weipai('query')" style="width: 108px" type="primary"
          size="mini">顺丰物流查询</el-button>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<style lang="scss" scoped>
.el-dropdown-menu__item+.el-dropdown-menu__item {
  margin-top: 5px;
}
</style>

<script>
import { weipai } from "./weipai.js";
import TimePicker from "./TimePicker.vue";

export default {
  name: "wei-pai",
  components: { TimePicker },
  props: {
    item: Object
  },
  data() {
    return {}
  },
  methods: {
    weipai: function(val) {
      weipai.call(this, this.item, val);
    }
  },
  created() { }
}
</script>



// WEBPACK FOOTER //
// src/views/order/order/dialog/weipai/weipai.vue